<template>
  <div class="language-switcher">
    <button 
      class="lang-btn"
      :class="{ active: currentLocale === 'en' }"
      :disabled="!availableLanguages.includes('en')"
      :title="languageExplanation('en')"
      :aria-label="languageExplanation('en') || 'English'"
      @click="switchLanguage('en')"
    >
      EN
    </button>
    <span class="separator">|</span>
    <button 
      class="lang-btn"
      :class="{ active: currentLocale === 'zh' }"
      :disabled="!availableLanguages.includes('zh')"
      :title="languageExplanation('zh')"
      :aria-label="languageExplanation('zh') || '中文'"
      @click="switchLanguage('zh')"
    >
      中文
    </button>
  </div>
</template>

<script>
import { computed } from 'vue'
import { alternatePath, PREFERENCE_KEY } from '@/runtime/locale-policy.mjs'
import indexDialogues from '@/data/dialogues.json'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n()
    const router = useRouter()
    const route = useRoute()
    
    const currentLocale = computed(() => locale.value)
    
    const availableLanguages = computed(() => {
      const match = route.path.match(/^\/(?:zh\/|en\/)?dialogues\/([^/]+)\/?$/)
      if (!match) return ['en', 'zh']
      return indexDialogues.find(item => item.slug === decodeURIComponent(match[1]))?.available_in || []
    })
    const languageExplanation = (language) => {
      if (availableLanguages.value.includes(language)) return ''
      if (availableLanguages.value.length === 1 && availableLanguages.value[0] === 'zh') {
        return currentLocale.value === 'zh' ? '此篇僅有中文原文' : 'This record is available only in its original Chinese.'
      }
      return currentLocale.value === 'zh' ? '此篇尚未提供此語言版本' : 'This record is not available in this language.'
    }
    const switchLanguage = (newLocale) => {
      if (!availableLanguages.value.includes(newLocale)) return
      try { localStorage.setItem(PREFERENCE_KEY, newLocale) } catch {}
      if (newLocale === currentLocale.value) return
      const path = alternatePath(route.meta.publicEntry, newLocale)
      if (path) router.push({ path, query: route.query, hash: route.hash })

    }
    
    return {
      currentLocale,
      availableLanguages,
      languageExplanation,
      switchLanguage
    }
  }
}
</script>

<style lang="sass" scoped>
.language-switcher
  display: flex
  align-items: center
  font-size: 0.9rem
  font-weight: 500
  
  .lang-btn
    background: none
    border: none
    color: inherit
    cursor: pointer
    padding: 4px 8px
    transition: opacity var(--dur-quick) var(--ease-out)
    font-size: inherit
    font-weight: inherit
    
    &:disabled
      cursor: not-allowed
      opacity: 0.3

    &:hover
      opacity: 0.7
    
    &.active
      opacity: 1
      text-decoration: underline
    
    &:not(.active)
      opacity: 0.6
  
  .separator
    margin: 0 4px
    opacity: 0.5
</style>